module.exports = __webpack_public_path__ + "static/media/mBank-SemiBold.0f56d471.woff";